// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-rejections/app-settings-rejections.less
// module id = 3201
// module chunks = 0